import React from "react";
import MainLayout from "../../../hoc/main";
import {Grid, TableData} from "../../../components";
import {connect} from "react-redux";
import {
    getDeletedGuestCardDatas,
    hardDeleteGuestCardData,
    restoreGuestCardData,
} from "../../../redux/modules/GuestCard/action";

class GuestCardTrash extends React.Component {
    constructor(props) {
        super(props);

        this.state = {
            datas: [],
        };
    }

    componentDidMount() {
        this.props.getDeletedGuestCardDatas();
    }

    UNSAFE_componentWillReceiveProps(np) {
        this.setState({
            datas: np.guestCard.datas,
        });
    }

    render() {
        // console.log(this.state.datas);
        const guestCardColumn = [
            {
                name: "Name",
                path: "name",
                show: true,
            },
            {
                name: "Number",
                path: "accessNumber",
                show: true,
            },
        ];

        return (
            <div className="p-6 mt-20 xl:mt-0 ">
                <Grid>
                    <TableData
                        path={this.props.location.pathname}
                        title={"GuestCard Category Data"}
                        data={this.props.guestCard.datas}
                        columns={guestCardColumn}
                        trashAction={true}
                        deleteAction={(id) => this.props.hardDeleteGuestCardData(id)}
                        restoreAction={(id) => this.props.restoreGuestCardData(id)}
                    />
                </Grid>
            </div>
        );
    }
}

const mapStateToProps = (state) => ({
    guestCard: state.guestCard,
});

const mapDispatchToProps = {
    getDeletedGuestCardDatas,
    hardDeleteGuestCardData,
    restoreGuestCardData,
};

export default MainLayout(
    connect(mapStateToProps, mapDispatchToProps)(GuestCardTrash)
);
